import React from 'react';
import classnames from 'classnames';
const baseClassName = 'px-4 py-5 sm:px-6';
export default function Panel({ children, className }) {
    return React.createElement("div", { className: classnames(baseClassName, className) }, children);
}
